export default __webpack_public_path__ + "static/comment-d439e7fa9493b49e19a241d73b9468e8.jpg";